<template lang="pug">
div.mt-3
  forms-generic-input-vue(
    ref="generic_input_vue",
    input_type="filled",
    input_field="components.forms.navigation_list.search",
    form_name="search_form",
    :auto_validates="false",
    @input_changed="filterValuesByInput",
    :default_value="valueInput",
    :button_classes="['inputReactive', 'mt-2']"
  )
  .result-list.mt-3(v-if="hasInput", :class="minHeightClass()")
    div(v-if="filteredListElements.length > 0")
      ul(v-for="element in filteredListElements", :key="element.id").pl-0
        navigation-list-element-vue(
          :elementId="element.id",
          :elementName="element.name",
          @perform:search="emitPerfomSearch"
        )
    #no_result_message.p-4(v-else)
      p {{ t("components.forms.navigation_list.no_results") }}
</template>

<script>
import mixins from 'common/mixins'
import { mapMutations } from 'vuex';

export default {
  name: 'list-by-input-search-vue',
  props: {
    hasExtraFilter: { type: Boolean, default: () => false },
    listElements: { type: Array, default: () => [] }
  },

  mixins: [mixins.translate, mixins.regex_utils],
  components: {
    "forms-generic-input-vue": () => import(
      /* webpackChunkName: "[request]" */ "components/forms/GenericInput"
    ),
    "navigation-list-element-vue": () => import(
      /* webpackChunkName: "[request]" */ "components/forms/NavigationListElement.vue"
    )
  },
  data: function () {
    return {
      valueInput: '',
      filteredListElements: []
    }
  },
  methods: {
    emitPerfomSearch(id){
      this.$emit('perform:search', id)
      this.valueInput = ''
    },
    minHeightClass() {
      return gon.current_app != "tol" ? "result-list__elements-filters" : "";
    },
    filterValuesByInput(input){
      this.valueInput = input
      let cleanInput = this.text_to_regextext(input)
      const regex = new RegExp(cleanInput, 'i')

      this.filteredListElements = this.listElements.filter(
        element => regex.test(element.name.toLowerCase())
      )
    },
    ...mapMutations(
      "search", ['setInputSearchText']
    ),
  },
  computed: {
    hasInput() {
      return this.valueInput.length > 2;
    }
  },
  watch: {
    valueInput(input){
      this.setInputSearchText(input)
      if(input.length > 2){
        this.$emit('toggle:hasInput', true)
      } else {
        this.$emit('toggle:hasInput', false)
      }
    },
    hasExtraFilter(value){
      if(value)
        this.valueInput = ''
    }
  }
};
</script>
